import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import { TextInput } from "../components/FormComponents";
import useDocumentTitle from "../components/useDocumentTitle";

function ForgottenPassword() {
	let navigate = useNavigate();
	useDocumentTitle("Forgotten Password");
	let { api } = useAppContext();

	const [email, setEmail] = useState("");
	const [formErrors, setFormErrors] = useState({});
	const [submissionError, setSubmissionError] = useState(null);
	const [submitting, setSubmitting] = useState(false);

	function handleEmailChange(e) {
		setEmail(e.target.value);
	}

	async function handleSubmit(e) {
		e.preventDefault();
		setSubmissionError(null);
		let errors = {};
		
		if (!email) {
			errors.email = "Email is required";
		}

		setFormErrors(errors);
		
		if (Object.keys(errors).length) {
			return;
		}
		setSubmitting(true);

		const { data, error } = await api.fetchData('/forgotten-password', 'POST', { email });

		if (data?.success) {
			navigate('/reset-password', { replace: true });
		} else {
			setSubmissionError(data?.error || error || 'An error occurred');
			setSubmitting(false);
		}
	}
	
	return (
		<div>
			<p className="auth-info-container__welcome">Enter your email address below and a password reset link will be sent to you.</p>
			<form>
				<TextInput
					label={null}
					name="email"
					type="email"
					value={email}
					onChange={handleEmailChange}
					required={true}
					error={formErrors?.email}
				/>
				{submissionError && <div className="alert-banner alert-banner__danger">{submissionError}</div>}
				<div className="auth-info-container__login-bottom">
					<button
						type="submit"
						className="btn btn-tertiary auth-info-container__button"
						onClick={handleSubmit}
						disabled={submitting}
					>
						{submitting ? 'Submitting...' : 'Reset Password'}
					</button>
					<p className="auth-info-container__small-link">
						<Link to="/login">Go To Login</Link>
					</p>
				</div>
			</form>
		</div>
	);
}

export default ForgottenPassword;